import { render } from "./YearGoals.vue?vue&type=template&id=67feabaa"
import script from "./YearGoals.vue?vue&type=script&lang=js"
export * from "./YearGoals.vue?vue&type=script&lang=js"

import "./YearGoals.vue?vue&type=style&index=0&id=67feabaa&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__